export function downloadDoc(args) {
	const { status, name, url, error } = args;

	if (status) {
		const fileLink = document.createElement("a");
		fileLink.href = url;
		fileLink.setAttribute("download", name);
		fileLink.setAttribute("target", "_blank");
		document.body.appendChild(fileLink);
		fileLink.click();
	} else {
		console.info(error);
	}
}
